module.exports = __webpack_public_path__ + "images/emoji/whale2.97748cb13dcc13e4b968.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/whale2.png
// module id = 2xDj
// module chunks = 24